<template>
    <div>
        <div class="card">
            <div class="card-header">Data Access Permissions</div>
            <div class="card-body">
                <div class="mb-3">
                <p>Allow Doctors to Access All My Past Consultations Data</p>
                <div class="mb-3">
                    <toggle-button :checkboxValue.sync="consent.pastConsultation"
                        @update:checkboxValue="updateConsentConsultations">
                    </toggle-button>
                    &nbsp;&nbsp;{{ consent.pastConsultation ? "Allowed" : "Disallowed" }}
                </div>
                <p>Last Updated: {{ consent.pastConsultationLastUpdated ? consent.pastConsultationLastUpdated : "NIL" }}</p>
                </div>
                <hr>
                <div>
                <p>Allow Doctors to Access All My Medical Reports</p>
                <div class="mb-3">
                    <toggle-button :checkboxValue.sync="consent.medicalReports"
                        @update:checkboxValue="updateConsentMedicalReports">
                    </toggle-button>
                    &nbsp;&nbsp;{{ consent.medicalReports ? "Allowed" : "Disallowed" }}
                </div>
                <p>Last Updated: {{ consent.medicalReportsLastUpdated ? consent.medicalReportsLastUpdated : "NIL" }}</p>
                </div>
            </div>
        </div>
        <popup-modal ref="popupUpdateSuccessful" :hasCloseButton="false" title="Permission Update">
        <template slot="content">
            <p>{{consent.submitMessage}}</p>
        </template>
        <template slot="footer">
            <button type="button" class="btn btn-primary btn-primary-insv" @click="dismissPopupSuccessful">Okay</button>
        </template>
    </popup-modal>
    </div>
</template>

<script>
import { convertToUserReadableDateTime } from '@/utilities';
import toggleButton from '@/components/toggle-button';
import popupModal from '@/components/popup-modal';

export default {
    'components': {
        toggleButton,
        popupModal
    },
    data () {
        return {
            'consent': {
                'pastConsultation': false,
                'pastConsultationLastUpdated': null,
                'medicalReports': false,
                'medicalReportsLastUpdated': null,
                'submitMessage': null
            }
        };
    },
    'methods': {
        getConsentConsultations () {
            this.axios.get('Profile/GetConsent', {
                'params': {
                    'consentType': 1001
                }
            }).then(({ data }) => {
                if (data.data) {
                    this.consent.pastConsultation = data.data.ia;
                    this.consent.pastConsultationLastUpdated = data.data.aa ? convertToUserReadableDateTime(data.data.aa) : null;
                }
            });
        },
        getConsentMedicalReports () {
            this.axios.get('Profile/GetConsent', {
                'params': {
                    'consentType': 1002
                }
            }).then(({ data }) => {
                if (data.data) {
                    this.consent.medicalReports = data.data.ia;
                    this.consent.medicalReportsLastUpdated = data.data.aa ? convertToUserReadableDateTime(data.data.aa) : null;
                }
            });
        },
        updateConsentConsultations () {
            this.consent.submitMessage = 'Updating your preference. Please wait...';
            this.$refs.popupUpdateSuccessful.show();

            this.axios.post('Profile/UpdateConsent', {
                'ct': 1001,
                'ia': this.consent.pastConsultation
            }).then(({ data }) => {
                this.consent.submitMessage = 'Permission updated successfully!';

                if (data.data) {
                    this.consent.pastConsultation = data.data.ia;
                    this.consent.pastConsultationLastUpdated = data.data.aa ? convertToUserReadableDateTime(data.data.aa) : null;
                }
            }).catch(() => {
                this.consent.submitMessage = 'Error updating your preference. Please try again.';
                this.getConsentConsultations();
            });
        },
        updateConsentMedicalReports () {
            this.consent.submitMessage = 'Updating your preference. Please wait...';
            this.$refs.popupUpdateSuccessful.show();

            this.axios.post('Profile/UpdateConsent', {
                'ct': 1002,
                'ia': this.consent.medicalReports
            }).then(({ data }) => {
                this.consent.submitMessage = 'Permission updated successfully!';
                if (data.data) {
                    this.consent.medicalReports = data.data.ia;
                    this.consent.medicalReportsLastUpdated = data.data.aa ? convertToUserReadableDateTime(data.data.aa) : null;
                }
            }).catch(() => {
                this.consent.submitMessage = 'Error updating your preference. Please try again.';
                this.getConsentMedicalReports();
            });
        },
        dismissPopupSuccessful () {
            this.$refs.popupUpdateSuccessful.hide();
        }
    },
    mounted () {
        this.getConsentConsultations();
        this.getConsentMedicalReports();
    }
};
</script>
